<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
              <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-2 col-md-12 col-2">
                    <h2>Filters & Search</h2>
                    </div>
                    <div class="col-lg-10 col-md-12 col-10 text-right bid">
                      <div class="input-group d-inline-flex justify-content-end">
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                        <i @click="search()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="search" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                        <button @click="addFilter()" type="button" class="btn btn-success rounded"><i class="fas fa-plus"></i> Add Filter/Search</button>
                         </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6">
            <div class="row xsOnly">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                          <div class="row">
                            <div class="col-md-9"></div>
                            <div class="col-md-3">
                                <toggle-button v-model="isSearchOnly" @change="search" style="padding: 5px;"/> SAVED SEARCHES
                            </div>
                        </div> 
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                              <th
                                  scope="col" 
                                  class="sort text-left"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'name'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'name'  ? 'sort-desc' : '']"  
                                  @click="sort('name')">Name</th>
                                <th
                                scope="col" 
                                class="sort text-left"
                                v-if="!isSearchOnly"
                                >status</th>
                                <th
                                scope="col" 
                                class="sort text-center"
                                >Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="savedFilters.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in savedFilters" :key="data.id">
                              <td class="text-left">{{data.name}}</td>
                              <td class="text-left" v-if="!isSearchOnly">
                                <toggle-button :sync="true" v-model="data.enable" @change="onChangeEventHandler(data)"/>
                               </td>
                               <td class="text-center">
                                <button @click="editFilter(data)" class="btn btn-primary" type="button">
                                    <i class="fas fa-check"></i>EDIT
                                  </button>
                                  <button @click="deleteFilter(data)" class="btn btn-danger" type="button">
                                    <i class="fas fa-trash"></i>DELETE
                                  </button>
                                  <button @click="duplicateFilter(data)" class="btn btn-info" type="button">
                                    <i class="fas fa-clone"></i>DUPLICATE
                                  </button>
                               </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getSavedFilters(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <AddFilter 
          v-if="showAddFilterModal"
          v-bind:selectedfilter="selectedFilter"
          @close="toggleAddFilterDataModal()"
        />  
    </div>    
    
</template>
<script>
import config from "@/config";
import authService from "@/authService";
// import Datepicker from 'vuejs-datepicker';
import AddFilter from "./AddFilter.vue"
export default {
  name: "imsCusipComponent",
  components : {
    AddFilter
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "id",
        sortOrder: "DESC",
        savedFilters : [],
        status :"NEW,ACTIVE",
        showAddFilterModal : false,
        selectedFilter : null,
        isSearchOnly : false
    };
  },
  methods: {
    onChangeEventHandler(filter){
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let addData = {
            "filterId":filter.id,
            "userId":authService.getUser().id,
            "status": filter.enable ? "ACTIVE" : "NEW",
            "autoBidFilterType": filter.autoBidFilterType,
          }
          this.$http
          .put(config.baseUrlAutoBidder + "/autobidder/filter-update-status",addData,auth)
          .then(() => {
            this.loading = false; 
            this.getSavedFilters();
           
          })
          .catch(() => {
              this.loading = false;              
          });

    },
    editFilter(filter){
      this.selectedFilter = filter;
      this.showAddFilterModal = !this.showAddFilterModal;
    },
    addFilter(){
      this.selectedFilter = null;
      this.showAddFilterModal = !this.showAddFilterModal;
    },
    duplicateFilter(filter){
      // Create a copy of the filter object without the 'id' field
      const filterCopy = { ...filter };
      delete filterCopy.id;
      filterCopy.name = filter.name+" duplicate";
      filterCopy.isDuplicate = true;
      // Assign the modified copy to the selectedFilter
      this.selectedFilter = filterCopy;

      // Toggle the modal
      this.showAddFilterModal = !this.showAddFilterModal;
    },
    deleteFilter(filter){
      var message = "Are you sure you want to delete?";
      this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
       
          this.$http
          .put(config.baseUrlAutoBidder + "/autobidder/filter-delete?filterId="+filter.id,"",auth)
          .then(() => {
            this.loading = false;  
            this.$alert("Deleted successfully","","success");            
            this.getSavedFilters();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
    },
    toggleAddFilterDataModal(){
      this.showAddFilterModal = !this.showAddFilterModal;
      this.getSavedFilters();
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getSavedFilters();
    },
    search(){
        this.currentPage = 1;
        this.getSavedFilters();  
    },
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 1;
        this.getSavedFilters();  
    },
    getSavedFilters(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        let autoBidType = this.isSearchOnly ? "SEARCH" : "FILTER"
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/filter-listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            this.status+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&userId="+
            authService.getUser().id+
            "&autoBidFilterType="+
            autoBidType,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(element => {
            if(element.status == "ACTIVE"){
              element.enable = true
            }else{
              element.enable = false

            }
          });
          this.savedFilters = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    }
   
  },
  mounted() {
    this.getSavedFilters();
  }
};
</script>
<style scoped>
  .psticky {
    position: sticky;
    top: -21px;
    z-index: 9999;
  }
</style>